import { type ReviewItem } from '../../Review/types.ts';

export const buildDependencyKey = (items: ReviewItem[]) => items.map(item => item.id).join('::');
